import { render, staticRenderFns } from "./AddParamLinkButton.vue?vue&type=template&id=1c118572&scoped=true"
import script from "./AddParamLinkButton.vue?vue&type=script&lang=js"
export * from "./AddParamLinkButton.vue?vue&type=script&lang=js"
import style0 from "./AddParamLinkButton.vue?vue&type=style&index=0&id=1c118572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c118572",
  null
  
)

export default component.exports